import axios, { AxiosError } from "axios";
import { FaqEntry, FaqSearchResponse, FaqSearchMatch } from "../types";

interface BackendResponse<T> {
  success?: boolean;
  data?: T;
  message?: string;
}

const FAQ_BASE_URL = "/faqs";

export const fetchFaqs = async (): Promise<FaqEntry[]> => {
  const response = await axios.get<BackendResponse<FaqEntry[]>>(FAQ_BASE_URL);
  const data = response.data?.data;

  if (Array.isArray(data)) {
    return data;
  }

  return [];
};

export const searchFaq = async (query: string): Promise<FaqSearchResponse> => {
  try {
    const response = await axios.get<
      BackendResponse<{
        query: string;
        match: FaqSearchMatch | null;
        suggestions: FaqEntry[];
      }>
    >(`${FAQ_BASE_URL}/search`, {
      params: { q: query },
    });

    const payload = response.data?.data;

    if (!payload) {
      return {
        query,
        match: null,
        suggestions: [],
      };
    }

    return {
      query: payload.query || query,
      match: payload.match ?? null,
      suggestions: Array.isArray(payload.suggestions)
        ? payload.suggestions
        : [],
    };
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<BackendResponse<null>>;
      const message =
        axiosError.response?.data?.message ||
        "We couldn't reach the FAQ service. Please try again.";

      throw new Error(message);
    }

    throw new Error("Something went wrong while searching FAQs.");
  }
};
